import NextImage from "next/legacy/image";
import { cloudflareLoader } from '/lib/services/helpers/cloudflareLoader';

const Image = ({ ...props }) => {
    return (
        <NextImage {...props} loader={cloudflareLoader} />
    )
}

export default Image